export default "__VITE_ASSET__a1b3ad23__"